@if (toasterService.isVisible$ | async) {
  <div class="toaster-container">
    <div [class]="`toaster-content ${toasterService.typeToast}`">
      <div class="toaster-progress" [style.animation-duration.ms]="durationMs"></div>
      <div class="toaster-body">
        <img
          [src]="getIconPath(toasterService.typeToast)"
          [alt]="getIconAlt(toasterService.typeToast)"
          width="24"
          height="24"
        />
        <p class="toaster-message">{{ displayMessage }}</p>
      </div>
    </div>
  </div>
}
